import pdf from './pdfReducer';
import responses from './responsesReducer';
import userDelegate from './userDelegateReducer';
import event from './eventReducer';
import search from './searchReducer';
import emailDelivery from './emailDeliveryReducer';
import accountOwner from './accountOwnerReducer';
import { combineReducers } from 'redux';
import user from './userReducer';
import tenantStats from './tenantStatsReducer';
import accountBasics from './accountBasicsReducer';
import accountAdmins from './accountAdminsReducer';
import configurationDefaults from './configurationDefaultsReducer';
import authentication from './authenticationReducer';
import selfLaunchAllowed from './selfLaunchAllowedReducer';
import logout from './logoutReducer';
import dialog from './dialog';
import roster from './rosterReducer';
import prioritize from './prioritize';
import aiReportSummary from './aiReportSummaryReducer';
import insights from '../features/ai-insights/reducers/insights';
import { __INTERNAL_CLEAR_STORE__, LOGOUT_DONE } from '../actions/actionTypes';
import PersistentStore from '../store/PersistentStore';

// https://stackoverflow.com/questions/35622588/how-to-reset-the-state-of-a-redux-store
// @formatter:off
const appReducer = combineReducers({
  user,
  tenantStats,
  accountBasics,
  accountAdmins,
  configurationDefaults,
  authentication,
  selfLaunchAllowed,
  dialog,
  accountOwner,
  emailDelivery,
  search,
  logout,
  event,
  userDelegate,
  roster,
  responses,
  pdf,
  prioritize,
  aiReportSummary,
  insights,
  // __REDUX_ABOVE_ME__
});
// @formatter:on

const rootReducer = (state, action) => {
  if (action.type === __INTERNAL_CLEAR_STORE__ || action.type === LOGOUT_DONE) {
    // Clear persistent store

    // Do not force the state back to initial or this causes a redirect loop
    state = undefined;
    PersistentStore.clear();
  }

  return appReducer(state, action);
};

export default rootReducer;
